export default "assets/images/background-image-section-2deed4c4.png";